import { InitialState } from '../state';
import { AppReducer } from './app-reducer';

export const trendChannelReducer: AppReducer<'SelectedTrendChannels'> = (
    state = InitialState.SelectedTrendChannels,
    action
): typeof state => {
    switch (action.type) {
        case 'TrendChannels/Selected':
            return {
                ...state,
                selectedChannels: action.payload.channels,
            };
        case 'TrendChannels/Graph':
            return {
                ...state,
                channelsForGraph: action.payload.channels,
            };

        default:
            return state;
    }
};
